import React from 'react';

function ComingSoon() {
  return (
    <React.Fragment>
      <main style={{ backgroundColor: '#f2eeed' }}>
        <section className="vh-100 d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center d-flex align-items-center justify-content-center">
                <div>
                  <img
                    className="img-fluid w-75"
                    src="images/helena.app.br.launch.png"
                    alt="404 not found"
                  />
                  <h1>
                    Coming <span className="fw-bolder text-primary">Soon</span>
                  </h1>
                  <p className="lead my-4">
                    We're working hard to bring you something amazing. Stay
                    tuned!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default ComingSoon;
